import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminUpdateProviderDepartmentOptionMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminUpdateProviderDepartmentOptionMutationResultFragment, AdminUpdateProviderDepartmentOptionMutationParams } from '@docpace/admin-graphql'

const typedAdminUpdateProviderDepartmentOptionMutationDocument = AdminUpdateProviderDepartmentOptionMutationDocument as TypedDocumentNode<AdminUpdateProviderDepartmentOptionMutationResultFragment, Partial<AdminUpdateProviderDepartmentOptionMutationParams>>

export function useAdminUpdateProviderDepartmentOptionMutation(opts?: useMutation.Options<AdminUpdateProviderDepartmentOptionMutationResultFragment, Partial<AdminUpdateProviderDepartmentOptionMutationParams>>){
    return useMutation(typedAdminUpdateProviderDepartmentOptionMutationDocument, opts)
}
